<template>
  <div class="authoriedStore">
    <div class="title">{{ $t('other.a2251') }}:</div>
    <div class="wrapper">
      <div class="imgbox" @click="openAuthorization()">
        <div class="mask">
          <p style="text-align:center;color:#ffff;margin-top:19px;font-weight:bold;">{{ $t('other.a2252') }}</p>
        </div>
      </div>
      <div class="imgbox" @click="getShopAuthorization_lazada()">
        <div class="mask">
          <p style="text-align:center;color:#ffff;margin-top:19px;font-weight:bold;">{{ $t('other.a2252') }}</p>

        </div>
      </div>
      <div class="imgbox" @click="authorTiktok()">
        <div class="mask">
          <p style="text-align:center;color:#ffff;margin:5px 0;font-weight:bold;">{{ $t('other.a2253') }}</p>
          <p style="text-align:center;color:#ffff;font-weight:bold;">{{ $t('other.a2254') }}{{ $t('other.a2252') }}</p>
        </div>
      </div>
      <div class="imgbox" @click="getShopAuthorization_TEMU()">
        <div class="mask">
          <p style="text-align:center;color:#ffff;margin-top:19px;font-weight:bold;">{{ $t('other.a2252') }}</p>

        </div>
      </div>
      <div class="imgbox" @click="authorTiktokEn()">
        <div class="mask">
          <p style="text-align:center;color:#ffff;margin:5px 0;font-weight:bold;">{{ $t('other.a2253') }}</p>
          <p style="text-align:center;color:#ffff;font-weight:bold;">{{ $t('other.a2254') }}{{ $t('other.a2252') }}</p>
        </div>
      </div>
      <div class="imgbox" @click="authorTiktokCustom()">
        <div class="mask">
          <p style="text-align:center;color:#ffff;margin:5px 0;font-weight:bold;">{{ $t('other.a2253') }}</p>
          <p style="text-align:center;color:#ffff;font-weight:bold;">{{ $t('other.a2254') }}{{ $t('other.a2252') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import shopaccessApi from '../../../api/moudles/shopaccess.js'
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo'))

    }
  },
  created() {
  },
  methods: {
    authorTiktok() {
      this.$confirm(this.$t('other.a2255'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a2256'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        shopaccessApi
          .getTiktopShopUrl({
            userId: this.userInfo.userId
          })
          .then(res => {
            if (res.code === 200) {

              window.open(res.data)

            } else {
              this.$message.warning(res.msg)
            }
          })
      })
    },
    authorTiktokEn() {
      this.$confirm(this.$t('other.a2255'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a2256'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        shopaccessApi
          .getTiktopShopUrlEn({
            userId: this.userInfo.userId
          })
          .then(res => {
            if (res.code === 200) {

              window.open(res.data)

            } else {
              this.$message.warning(res.msg)
            }
          })
      })
    },
    authorTiktokCustom() {
      this.$confirm(this.$t('other.a2255'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a2256'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        shopaccessApi
          .getTiktokUSShopUrlCustom({
            userId: this.userInfo.userId
          })
          .then(res => {
            if (res.code === 200) {

              window.open(res.data)

            } else {
              this.$message.warning(res.msg)
            }
          })
      })
    },
    getShopAuthorization_lazada() {

      this.$confirm(this.$t('other.a2255'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a2256'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        let url = "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://erp.shopsbu.com/erp/callBack/lazadaCallBack&client_id=123391&state=" + this.userInfo.userId;
        window.open(url)
      })
    },
    //点击弹窗让用户填写TEMU授权信息
    getShopAuthorization_TEMU() {
      this.$emit('changAuthoriedStore','TEMU')
    },
    openAuthorization() {
      let url = location.href
      let baseUrl = ''
      this.$confirm(this.$t('other.a2255'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a2256'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        shopaccessApi
          .getParnetUrl({
            partnerId: JSON.parse(localStorage.getItem('userInfo')).partnerId
          })
          .then(res => {
            if (res.code === 200) {
              console.log('desc', res.data)
              window.open(res.data)
            } else {
              this.$message.warning(res.msg)
            }
          })
      })


      //  if(url.indexOf('shopsbu') > -1){
      //     // window.open(baseUrl)
      //     shopaccessApi
      // 		.getParnetUrl({
      // 			partnerId:JSON.parse(localStorage.getItem('userInfo')).partnerId
      // 		})
      // 		.then(res => {
      // 		if(res.code === 200 ){
      // 		console.log('desc',res.data)
      // 		window.open(res.data)
      // 		}else{
      // 		this.$message.warning(res.msg)
      // 		}
      // 		})
      // 	}else if(url.indexOf('shopsooo') > -1){
      // 		shopaccessApi
      // 		.getParnetUrl({
      // 			partnerId:JSON.parse(localStorage.getItem('userInfo')).partnerId
      // 		})
      // 		.then(res => {
      // 		if(res.code === 200 ){
      // 		console.log('desc',res.data)
      // 		window.open(res.data)
      // 		}else{
      // 		this.$message.warning(res.msg)
      // 		}
      // 		})
      // 	}

    },

  }
}

</script>
<style lang="scss" scoped>
.authoriedStore {
  margin: 10px;
  box-sizing: border-box;
  padding: 0 5px 15px 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

  .title {
    box-sizing: border-box;
    padding: 10px 5px 10px 5px;
    font-size: 18px;
    border-bottom: 1px solid #eee;
    font-weight: 600;
  }


  .wrapper {
    display: flex;
    margin-top: 10px;

  }

  .imgbox {
    width: 150px;
    height: 56px;
    margin: 2px 5px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
  }

  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    opacity: 0;
  }

  .imgbox:hover .mask {
    opacity: 1;
  }




  .imgbox:nth-child(2) {
    background-image: url('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0271dc95d8de4b4c810aeb48d4e8a083.png');
    background-position: 50% 18%;
    background-size: 75%;
    background-repeat: no-repeat;
    background-color: #eee;

  }

  .imgbox:nth-child(1) {
    background-image: url('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0271dc95d8de4b4c810aeb48d4e8a083.png');
    background-position: 50% 8%;
    background-size: 75%;
    background-repeat: no-repeat;
    background-color: #eee;

  }

  .imgbox:nth-child(3) {
    background-image: url('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0271dc95d8de4b4c810aeb48d4e8a083.png');
    background-position: 50% 92%;
    background-size: 75%;
    background-repeat: no-repeat;
    background-color: #eee;

  }


.imgbox:nth-child(4) {
  background-image: url('../../../assets/img/temu.png');
  background-position: 0% 0%;
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #eee;

}
.imgbox:nth-child(5) {
  background-image: url('../../../assets/img/tu1.png');
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #eee;

}
.imgbox:nth-child(6) {
  background-image: url('../../../assets/img/tu2.png');
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #eee;

}


}
</style>